import {
  TEditAppealProduct,
  TEditAppealRequest,
  TProduct,
} from 'feature/appeals/type'

//  приведение данных о заявки к нужному виду для отправки

export const prepareProductsToSubmit = (
  editableProduct: TEditAppealProduct,
  products: TEditAppealProduct[],
  product: TProduct,
  appeal: TEditAppealRequest,
): TEditAppealRequest => {
  const newProducts = products.map(productItem => {
    if (productItem.id === product.id) {
      return {
        ...productItem,
        parameters: editableProduct.parameters,
      }
    }
    return productItem
  })

  const newAppeal = {
    uid: appeal.uid,
    orderId: appeal.orderId,
    products: newProducts,
  }

  return newAppeal
}
